export interface Skill {
  name: string;
  proficiency: number;
}

export const skills = {
  programming: [
    { name: "C/C++", proficiency: 90 },
    { name: "Python", proficiency: 85 },
    { name: "Java", proficiency: 80 },
    { name: "JavaScript/TypeScript", proficiency: 85 },
    { name: "Kotlin", proficiency: 75 },
    { name: "Dart", proficiency: 70 },
    { name: "Assembly", proficiency: 70 },
    { name: "OOP", proficiency: 88 }
  ] as Skill[],
  
  web: [
    { name: "HTML/CSS", proficiency: 88 },
    { name: "React", proficiency: 85 },
    { name: "Node.js", proficiency: 75 },
    { name: "Express.js", proficiency: 75 },
    { name: "Django", proficiency: 70 }
  ] as Skill[],
  
  mobile: [
    { name: "Flutter", proficiency: 80 },
    { name: "React Native", proficiency: 75 },
    { name: "Android (Java/Kotlin)", proficiency: 78 }
  ] as Skill[],
  
  databases: [
    { name: "SQL", proficiency: 85 },
    { name: "MySQL", proficiency: 85 },
    { name: "PostgreSQL", proficiency: 80 },
    { name: "Firebase", proficiency: 85 }
  ] as Skill[],
  
  hardware: [
    { name: "VHDL/Verilog", proficiency: 75 },
    { name: "Circuit Design", proficiency: 85 },
    { name: "PCB Design", proficiency: 80 },
    { name: "Digital Logic", proficiency: 88 },
    { name: "Microcontrollers", proficiency: 85 },
    { name: "VLSI", proficiency: 75 },
    { name: "PSPICE/LTSPICE", proficiency: 80 },
    { name: "Xilinx/Intel FPGA Tools", proficiency: 75 }
  ] as Skill[],
  
  ai: [
    { name: "Machine Learning", proficiency: 80 },
    { name: "TensorFlow", proficiency: 80 },
    { name: "PyTorch", proficiency: 75 }
  ] as Skill[],
  
  devops: [
    { name: "Git/GitHub", proficiency: 90 },
    { name: "Docker", proficiency: 80 },
    { name: "AWS/Cloud Services", proficiency: 70 },
    { name: "ROS", proficiency: 65 }
  ] as Skill[],
  
  other: [
    { name: "MATLAB", proficiency: 85 },
    { name: "Computer Networks", proficiency: 82 },
    { name: "Network Security", proficiency: 75 }
  ] as Skill[]
};

export const certifications = [
  {
    name: "AWS Certified Solutions Architect",
    issuer: "Amazon Web Services",
    date: "2023",
    link: "#"
  },
  {
    name: "TensorFlow Developer Certificate",
    issuer: "Google",
    date: "2022",
    link: "#"
  },
  {
    name: "Cisco Certified Network Associate (CCNA)",
    issuer: "Cisco",
    date: "2021",
    link: "#"
  }
];